/**
 * Additional Info inputs shown after Ask Qty. Values and limits come from the
 * draft response `inputs[summary_id]` (same payload as the Pricer's Additional
 * Info popup) and are saved through PUT /option-rows/{id}/additional-info.
 */
export const QUICK_ADD_INPUT_COLUMNS = [
  { field: "average", headerName: "Average", width: 80 },
  { field: "cost_of_carry", headerName: "Cost of Carry", width: 110 },
  { field: "risk_free", headerName: "Risk Free", width: 90 },
  { field: "black76_fmax", headerName: "Fmax", width: 80 },
  { field: "black76_price_steps", headerName: "Price steps", width: 100 },
  { field: "black76_time_steps", headerName: "Time steps", width: 100 },
];

export const QUICK_ADD_INPUT_FIELDS = QUICK_ADD_INPUT_COLUMNS.map(
  (col) => col.field
);

function rowDataOf(node) {
  return node?.group ? node?.aggData : node?.data;
}

function inputFor(params, field) {
  if (params?.node?.level !== 0) return null;
  const summaryId = rowDataOf(params.node)?.summary_id;
  return params?.context?.inputs?.[summaryId]?.[field] ?? null;
}

/** Column defs for the inputs; values come from grid context `inputs`. */
export function buildQuickAddInputColumns() {
  return QUICK_ADD_INPUT_COLUMNS.map((col) => ({
    headerName: col.headerName,
    field: col.field,
    colId: `quick_add_${col.field}`,
    minWidth: col.width,
    width: col.width,
    valueGetter: (params) => inputFor(params, col.field)?.value ?? "",
    editable: (params) => Boolean(inputFor(params, col.field)?.is_editable),
  }));
}
